<script setup lang="ts">
import { inject } from "vue";
import type { BadgeProps } from "./ColorBadge.vue";

const props = defineProps<{
  name: string;
  icon?: string;
  disabled?: boolean;
  badge?: BadgeProps;
}>();
const selectedTabName = inject("selectedTabName");
</script>

<template>
  <div class="tab-content" v-if="props.name === selectedTabName">
    <slot />
  </div>
</template>

<style scoped>
.tab-content {
  width: 100%;
}
</style>
